import { render } from "./ProductStoryCard.vue?vue&type=template&id=e03dbc8c"
import script from "./ProductStoryCard.vue?vue&type=script&lang=js"
export * from "./ProductStoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__